import {useCallback} from 'react';
import AnalyticsService, {
  eventNames,
} from '@/services/analytics/AnalyticsService';

type StoreFlowStartedEventParams = {
  flow_id?: string;
  product_type?: string;
  source: string;
};

function useStoreFlowStartedEvent(flowName?: string) {
  const storeFlowStarted = useCallback(
    ({
      flow_id = '',
      product_type = '',
      source,
    }: StoreFlowStartedEventParams) => {
      const flow = flowName ? AnalyticsService.getFlow(flowName) : undefined;
      AnalyticsService.dispatchEvent(
        eventNames.CONTENT_STUDIO_STORE_FLOW_STARTED,
        {
          flow_id: flow?.flow_id || flow_id,
          product_type,
          source,
        }
      );
    },
    []
  );

  return {storeFlowStarted};
}

export default useStoreFlowStartedEvent;
